import { render, staticRenderFns } from "./SessionExpiredAlert.vue?vue&type=template&id=7331d736"
import script from "./SessionExpiredAlert.vue?vue&type=script&lang=js"
export * from "./SessionExpiredAlert.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports